import axios from "axios";
import { keycloakService } from "@Services/keycloak";
import { tokenRefreshService } from "@Services/tokenRefresh";

/**
 * Cliente axios para a API de gestão (fonte de clientes e permissões do usuário).
 * Injeta Bearer token + x-customer-id (empresa atualmente selecionada) — é o
 * escopo por empresa que garante que o usuário comercial só enxergue suas empresas.
 */
const apiFleetManager = axios.create({
  baseURL: process.env.REACT_APP_API_MANAGEMENT_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

let forbiddenCallback: ((message: string) => void) | null = null;

export const setSessionExpiredCallback = (callback: () => void) => {
  tokenRefreshService.setSessionExpiredCallback(callback);
};

export const setForbiddenCallback = (callback: (message: string) => void) => {
  forbiddenCallback = callback;
};

apiFleetManager.interceptors.request.use(async (config) => {
  await keycloakService.ensureValidToken();

  const token = keycloakService.getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const customerId = localStorage.getItem("currentCompanyId");
  if (customerId) {
    config.headers["x-customer-id"] = customerId;
  }

  return config;
});

apiFleetManager.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      return tokenRefreshService.handle401Error(error, apiFleetManager);
    }

    // Erro 403 - Proibido (sem permissão)
    if (error.response?.status === 403) {
      const skipForbiddenHandler = (error.config as any)?.skipForbiddenHandler;
      const message =
        error.response?.data?.message ||
        "Você não possui permissão para realizar esta ação.";
      if (forbiddenCallback && !skipForbiddenHandler) {
        forbiddenCallback(message);
      }
    }

    return Promise.reject(error);
  }
);

export default apiFleetManager;
